import { render, staticRenderFns } from "./FilterLaporanKebidanan.vue?vue&type=template&id=38724ed8&scoped=true&"
import script from "./FilterLaporanKebidanan.vue?vue&type=script&lang=ts&"
export * from "./FilterLaporanKebidanan.vue?vue&type=script&lang=ts&"
import style0 from "./FilterLaporanKebidanan.vue?vue&type=style&index=0&id=38724ed8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38724ed8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCol,VIcon,VRow,VSelect,VTextField})
